import { Box, Button, Divider, Image, Text } from '@chakra-ui/react';
import { useState } from 'react';
import { CartItemProps, SelectedVariantTypeState } from '../../interfaces/components';
import Counter from './Counter';
import { Trash } from '../../Icons/Trash';
import React from 'react';
import { debounce } from '../../utils';
import { Heart } from '../../Icons/Heart';

function CartItem({ cartItem, onItemRemove, updateCart, addToWishlist }: CartItemProps) {
  const { quantity, id, imageSrc, name, price, selectedVariantAttributes } = cartItem;
  const [productCount, setProductCount] = useState<number>(quantity);

  const debouncedUpdateCart = debounce(updateCart, 1000);

  const onIncrease = () => {
    setProductCount((state) => ++state);
    debouncedUpdateCart(id, productCount + 1);
  };

  const onDecrease = () => {
    if (productCount > 1) {
      setProductCount((state) => --state);
      debouncedUpdateCart(id, productCount - 1);
    }
  };

  return (
    <Box overflow="hidden">
      <Box
        w="100%"
        h="auto"
        display="flex"
        flexDirection="column"
        gap="20px"
        key={id}
        padding="20px 0px"
        overflow="hidden"
      >
        <Box display="flex" gap="3" transition="0.2s all" padding="5px" borderRadius="20px">
          <Image src={imageSrc} w="130px" h="130px" alt="product" objectFit="cover" borderRadius="16px" />
          <Box display="flex" flexDirection="column" gap="10px">
            <Text
              fontSize={['12px', '12px']}
              fontFamily="WorkSans-Bold-Web"
              textAlign="left"
              color="rgba(15, 22, 33, 1)"
            >
              {name}
            </Text>

            {selectedVariantAttributes &&
              Object.keys(selectedVariantAttributes as SelectedVariantTypeState)?.length > 0 &&
              Object.keys(selectedVariantAttributes as SelectedVariantTypeState)?.map((key: string) => (
                <Box display="flex" gap="5px" key={key}>
                  <Text
                    fontSize={['12px', '12px']}
                    fontFamily="WorkSans-Semibold-Web"
                    textAlign="left"
                    color="rgba(15, 22, 33, 1)"
                  >
                    {(selectedVariantAttributes as SelectedVariantTypeState)[parseInt(key)]?.type || 'Unknown Type'}:
                  </Text>
                  <Text
                    fontSize={['12px', '12px']}
                    fontFamily="WorkSans-Regular-Web"
                    textAlign="left"
                    color="rgba(15, 22, 33, 1)"
                  >
                    {(selectedVariantAttributes as SelectedVariantTypeState)[parseInt(key)]?.value || 'Unknown Value'}
                  </Text>
                </Box>
              ))}
          </Box>
        </Box>

        <Box display="flex" p="0px 10px" flexDirection="column" alignItems="flex-end" gap={2}>
          <Box width="100%" display="flex" alignItems="center" justifyContent="space-between">
            <Counter count={productCount} onIncrease={onIncrease} onDecrease={onDecrease} />
            <Text
              fontSize={['16px', '16px']}
              fontFamily="WorkSans-Bold-Web"
              textAlign="right"
              color="rgba(15, 22, 33, 1)"
            >
              ${(productCount * price).toFixed(2)}
            </Text>
          </Box>

          <Button
            rightIcon={<Heart stroke="rgba(71, 80, 95, 1)" boxSize={[4, 4, 5]} />}
            variant="link"
            fontSize={['10px', '10px']}
            fontFamily="WorkSans-Regular-Web"
            textAlign="right"
            color="rgba(71, 80, 95, 1)"
            onClick={addToWishlist}
          >
            Save for later
          </Button>

          <Button
            rightIcon={<Trash boxSize={[4, 4, 5]} stroke="currentColor" />}
            variant="link"
            fontSize={['10px', '10px']}
            fontFamily="WorkSans-Regular-Web"
            textAlign="right"
            color="rgba(71, 80, 95, 1)"
            onClick={onItemRemove}
          >
            Remove
          </Button>
        </Box>
      </Box>

      <Divider orientation="horizontal" borderColor="#C2C2C2" />
    </Box>
  );
}

export default CartItem;
